import React from 'react';
import styles from './Tariffs.module.scss';
import { TariffsRowProps } from './Tariffs.type';
import clsx from 'clsx';
import dynamic from 'next/dynamic';
import { Swiper, SwiperSlide } from 'swiper/react';

const Offer = dynamic(() => import('./Offer/Offer'), {
    ssr: false,
});

const TariffsRow: React.FC<TariffsRowProps> = ({
    blockContentClassName,
    tariffs,
}) => {
    return (
        <div className={styles.block}>
            <div
                className={
                    blockContentClassName ??
                    clsx(
                        styles.blockContent,
                        tariffs?.length > 3 && styles.longList
                    )
                }
            >
                <Swiper className={styles.swiper} setWrapperSize width={286}>
                    {tariffs.map((item, idx) => (
                        <SwiperSlide key={`${item.name}-${idx}`}>
                            <div
                                className={styles.blockItem}
                                key={`${item.name}-${idx}`}
                            >
                                <Offer {...item} />
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </div>
    );
};

export default TariffsRow;
